@if (rootModel()) {
<div class="aspect-tree">
  <span #menuTrigger style="position: fixed" [matMenuTriggerFor]="menu" [style.left]="menuPosition.x + 'px'" [style.top]="menuPosition.y + 'px'"></span>
  <app-aspect-node [model]='rootModel()'></app-aspect-node>
  <mat-menu #menu="matMenu">
    <ng-template matMenuContent let-component="component" let-menu="menu">
      <button mat-menu-item [disabled]="!menu.faction" (click)="onFaction()">
        <mat-icon>widgets</mat-icon>
        <span>New Faction</span>
      </button>
      <button mat-menu-item [disabled]="!menu.aspect" (click)="onPrototype()">
        <mat-icon>insert_drive_file</mat-icon>
        <span>New Prototype</span>
      </button>
      <button mat-menu-item [disabled]="!menu.aspect" (click)="onAspect()">
        <mat-icon>extension</mat-icon>
        <span>New Aspect</span>
      </button>
      <button mat-menu-item [disabled]="!menu.delete" (click)="onDelete(current)">
        <mat-icon>close</mat-icon>
        <span>Delete</span>
      </button>
      <button mat-menu-item [disabled]="!menu.cut" (click)="onCut(current)">
        <mat-icon>flip_to_front</mat-icon>
        <span>Cut</span>
      </button>
      <button mat-menu-item [disabled]="!menu.copy" (click)="onCopy(current)">
        <mat-icon>flip_to_back</mat-icon>
        <span>Copy</span>
      </button>
      <button mat-menu-item [disabled]="!menu.paste" (click)="onPaste()">
        <mat-icon>library_add</mat-icon>
        <span>Paste</span>
      </button>
    </ng-template>
  </mat-menu>
</div>
}
